import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/static-assets';

export class StaticAssetService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}
  listSome(params: types.ListSomeParameters): Promise<types.ListSomeAssetsResponse> {
    throw new Error('Method not implemented.');
  }
  async getModel(params: types.GetModelParameters): Promise<types.FetchModelResponse> {
    return (
      await this.axios.post(`/asset/staticasset/fetch`, {
        ...params.body,
      })
    ).data;
  }
  async getModelGeometry(
    params: types.GetModelGeometryParameters,
  ): Promise<types.FetchGeometryResponse> {
    return (
      await this.axios.post(`/asset/staticasset/fetchgeometry`, {
        ...params.body,
      })
    ).data;
  }

  deleteModel(params: types.DeleteModelParameters): Promise<types.DeleteModelResponse> {
    throw new Error('Method not implemented.');
  }
  transform(params: types.TransformParameters): Promise<types.TransformModelresponse> {
    throw new Error('Method not implemented.');
  }
  async save(params: types.SaveParameters): Promise<types.SaveModelResponse> {
    return (
      await this.axios.post(`/asset/staticasset/save`, {
        ...params.body,
      })
    ).data;
  }
}
